import { Card } from "@ndd/ui";
import React from "react";
import { Badge } from "../badge";
import { scorecardRatingDisplay } from "../../lib/analysis-display";
import {
  baselineFormatLine,
  type BaselineSummary,
  type ScorecardSectionTally,
} from "../../lib/scorecard-workbench-baseline";
import { FactsLine } from "./facts-line";

function SectionTally({
  section,
}: {
  section: ScorecardSectionTally;
}): React.ReactElement {
  return (
    <div className="space-y-1.5">
      <div className="flex items-baseline justify-between gap-3">
        <h4 className="text-sm font-semibold text-foreground">{section.title}</h4>
        <span className="text-body text-muted-foreground">
          {section.itemCount} items · this is the reference
        </span>
      </div>
      <div className="flex flex-wrap gap-1.5">
        {section.counts.map((entry) => (
          <Badge
            key={entry.rating}
            variant={scorecardRatingDisplay[entry.rating].badgeVariant}
          >
            {entry.count} {entry.label}
          </Badge>
        ))}
      </div>
    </div>
  );
}

/**
 * What production already produced for this Session, as counts rather than
 * content: the Scorecard itself opens in the spotlight, not here.
 */
export function BaselineSummaryCard({
  summary,
  modelLabel,
}: {
  summary: BaselineSummary;
  modelLabel: string;
}): React.ReactElement {
  return (
    <Card className="border-2 p-4">
      <div className="flex items-center gap-2">
        <h3 className="text-base font-semibold text-foreground">Baseline</h3>
        <Badge variant="category">Production</Badge>
      </div>
      <FactsLine facts={summary.facts} modelLabel={modelLabel} />
      <p className="mt-3 rounded-md bg-muted px-3 py-2 text-body text-foreground">
        {baselineFormatLine(summary.sections, summary.sectionsReceived)}
      </p>
      <div className="mt-3 space-y-3">
        {summary.sections.map((section) => (
          <SectionTally key={section.name} section={section} />
        ))}
      </div>
    </Card>
  );
}
